import { CARD_TINT, UNIFORM_PROPS, PIN_TYPE } from 'common/constants';

/**
 * List of supported other properties, divided into conditional groups
 * These properties are behave identical to "styles"(aka. cssProps),
 * also each key in group is under influence of the css|state inheritance, but not rendered to DOM automatically.
 * Each corresponding component(BB) uses these properties by his own logic manually
 */
export const otherProps = {
	pin: {
		[PIN_TYPE]: PIN_TYPE,
	},
	box: {
		boxType: 'boxType',
	},
	card: {
		tint: CARD_TINT,
		backgroundVideo: 'backgroundVideo',
		backgroundPoster: 'backgroundPoster',
		muted: 'muted',
		loop: 'loop',
	},
	shape: {
		shapeType: 'shapeType',
		lineDir: 'lineDir',
	},
	button: {
		buttonShapeType: 'buttonShapeType',
	},
	text: {
		tag: 'tag',
	},
	embed: {
		embedCode: 'embedCode',
	},
	contentLayout: {
		contentHeight: 'contentHeight',
		contentAlignY: 'contentAlignY',
		contentMarginTop: 'contentMarginTop',
		contentMarginBottom: 'contentMarginBottom',
		contentMarginLeft: 'contentMarginLeft',
		contentMarginRight: 'contentMarginRight',
	},
};

export const uniformProps = UNIFORM_PROPS;
